import React from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { useAccount, useMsal } from '@azure/msal-react';
import { Logo } from './index';
import { PlaygroundTheme } from '../../Theme';

const useStyles = createUseStyles<string, unknown, PlaygroundTheme>((theme) => ({
  userAvatar: {
    marginTop: 2,
    backgroundColor: theme.themePrimary,
    '& svg': {
      cursor: 'default',
    },
  },
}));

export const UserIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.7545 14.4597C18.9966 14.4597 20.0034 15.4665 20.0034 16.7086V17.284C20.0034 18.1783 19.6838 19.0431 19.1023 19.7225C17.5329 21.556 15.1457 22.4608 12.0004 22.4608C8.8545 22.4608 6.46849 21.5557 4.90219 19.7214C4.32242 19.0425 4.00391 18.179 4.00391 17.2862V16.7086C4.00391 15.4665 5.01076 14.4597 6.25278 14.4597H17.7545ZM17.7545 15.9597H6.25278C5.83919 15.9597 5.50391 16.295 5.50391 16.7086V17.2862C5.50391 17.8219 5.69502 18.34 6.04287 18.7473C7.29618 20.215 9.26206 20.9608 12.0004 20.9608C14.7387 20.9608 16.7063 20.215 17.9627 18.7471C18.3117 18.3394 18.5034 17.8205 18.5034 17.284V16.7086C18.5034 16.295 18.1681 15.9597 17.7545 15.9597ZM12.0004 2.46435C14.7618 2.46435 17.0004 4.70293 17.0004 7.46435C17.0004 10.2258 14.7618 12.4644 12.0004 12.4644C9.23894 12.4644 7.00036 10.2258 7.00036 7.46435C7.00036 4.70293 9.23894 2.46435 12.0004 2.46435ZM12.0004 3.96435C10.0674 3.96435 8.50036 5.53136 8.50036 7.46435C8.50036 9.39735 10.0674 10.9644 12.0004 10.9644C13.9334 10.9644 15.5004 9.39735 15.5004 7.46435C15.5004 5.53136 13.9334 3.96435 12.0004 3.96435Z" fill="white" />
  </svg>
);

const formatName = (name: string) => {
  if (!name) {
    return '';
  }
  return name.split(' ').map((n) => n[0].toUpperCase()).join('');
};

export const UserAvatar = () => {
  const classes = useStyles();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const letters = formatName(account?.name || '');

  return (
    <Logo
      size="small"
      className={classnames(classes.userAvatar, 'user-avatar')}
      text={letters || <UserIcon />}
    />
  );
};
